import { useEffect, useState } from "react";
import { API, createCnoDelivery } from "../../../services/api";
import {
    defaultDriverId,
    deliveryErrorMessage,
    initialDeliverySelection,
    todayIsoDate,
    toggleSelection,
    validateDelivery,
} from "../model/cnoDeliveryRules";

function useDeliveryDrivers() {
    const [drivers, setDrivers] = useState([]);
    const [driverId, setDriverId] = useState("");

    useEffect(() => {
        let cancelled = false;
        API.get("/admin/delivery-plannings/drivers", { noRedirectOn401: true })
            .then(response => {
                if (cancelled) return;
                const loadedDrivers = Array.isArray(response.data) ? response.data : [];
                setDrivers(loadedDrivers);
                setDriverId(current => current || defaultDriverId(loadedDrivers));
            })
            .catch(() => {
                if (!cancelled) setDrivers([]);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return { drivers, driverId, setDriverId };
}

// État et envoi du formulaire de création d'une livraison CNO.
export default function useCreateDelivery(patients, onCreated) {
    const [deliveryDate, setDeliveryDate] = useState(todayIsoDate);
    const { drivers, driverId, setDriverId } = useDeliveryDrivers();
    const [selectedIds, setSelectedIds] = useState(() => initialDeliverySelection(patients));
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    const toggle = (id, checked) => setSelectedIds(current => toggleSelection(current, id, checked));

    const submit = async event => {
        event.preventDefault();
        const result = validateDelivery({ deliveryDate, selectedIds });
        if (result.error) {
            setError(result.error);
            return;
        }
        setSaving(true);
        setError("");
        try {
            await createCnoDelivery({
                deliveryDate,
                driverId: driverId ? Number(driverId) : null,
                patientIds: result.patientIds,
            });
            onCreated();
        } catch (err) {
            setError(deliveryErrorMessage(err));
        } finally {
            setSaving(false);
        }
    };

    return {
        deliveryDate, setDeliveryDate, drivers, driverId, setDriverId,
        selectedIds, toggle, error, saving, submit,
    };
}
